<template>
  <div>
    <div class="row"
         style="justify-content: flex-end;align-items: center;margin-right:100px;margin-top:-32px;margin-bottom:30px">
      <div class="toptip">
        总容量{{spaceMax}}MB（剩余
        <span style="color:#0b8586">{{parseInt(spaceMax-spentSpace)}}</span>
        MB）
      </div>
      <el-select v-model="type"
                 @change="getList"
                 size="small"
                 placeholder="请选择">
        <el-option v-for="item in typeList"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="listbox">
      <table>
        <thead>
          <tr>
            <th>课程标题</th>
            <th style="width:120px">课程封面</th>
            <th style="width:80px">类型</th>
            <th style="width:180px">提交时间</th>
            <th>审核状态</th>
            <th style="width:80px">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in storeList"
              :key="index">
            <td>{{item.c_Title}}</td>
            <td>
              <img :src="item.coverpicture"
                   style="width:65px;height:45px"
                   v-show="item.coverpicture"
                   alt="">
            </td>
            <td>{{item.resType==2?'视频':(item.resType==3?'音频':'PDF')}}</td>
            <td>{{item.createDate}}</td>
            <td>
              <span v-show="item.c_auditType==0">待审核{{item.c_auditContent!=''&&item.c_auditContent!=null?'，'+item.c_auditContent:''}}</span>
              <span v-show="item.c_auditType==9">审核通过{{item.c_auditContent!=''&&item.c_auditContent!=null?'，'+item.c_auditContent:''}}</span>
              <span v-show="item.c_auditType==-1">审核未通过{{item.c_auditContent!=''&&item.c_auditContent!=null?'，'+item.c_auditContent:''}}</span>
            </td>
            <td>
              <img style="margin-right:10px;cursor: pointer;"
                   src="../../assets/img/icon/bianji.png"
                   @click="toUpdataResources(item.id)"
                   v-show="item.c_auditType!=9"
                   alt="">
              <el-popconfirm title="您确定要删除吗？"
                             @confirm="toDeleteResources(item.id)">
                <img src="../../assets/img/icon/shanchu.png"
                     style="cursor: pointer;"
                     v-show="item.c_auditType!=9"
                     slot="reference"
                     alt="" />
              </el-popconfirm>
              <img src="../../assets/img/icon/yulan.png"
                   style="cursor: pointer;"
                   v-show="item.c_auditType==9"
                   @click="toShowResources(item.id)"
                   alt="">
            </td>
          </tr>
          <tr v-show="storeList.length<1">
            <td colspan="6">暂无课程信息</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination :total="pageCount"
                v-show="storeList.length>0"
                :limit="pageSize"
                :page="pageIndex"
                @page-change="pageChange"></pagination>
    <el-dialog :visible.sync="isAddRes2"
               @close="closeAddRes"
               class="AddResources"
               :show-close="false"
               title="课程资源上传"
               width="600px">
      <div class="row">
        <span>标题：</span>
        <el-input placeholder="请输入标题"
                  v-model="title"
                  style="width:500px"
                  clearable>
        </el-input>
      </div>
      <div class="row">
        <span>视频：</span>
        <webupload fileaccept=".mp4"
                   :uploadtype="2"
                   :orgid="orgid"
                   class="addt4box"
                   :onSuccess="handleSuccess2"
                   :beforeResUpload="beforeResUpload">
          <div class="addmp4box"
               v-show="!resUrl">
            <img src="../../assets/img/icon/import.png"
                 alt="">
            <span>上传视频</span>
          </div>
          <div v-show="resUrl"
               class="mp4box">
            <video :src="resUrl"
                   controls="controls"
                   controlsList='nodownload'
                   @click.stop></video>
            <span>修改上传</span>
          </div>
        </webupload>
      </div>
      <div class="row">
        <span>封面：</span>
        <webupload fileaccept=".jpg,.jpeg,.png"
                   :Maxfileszie="3"
                   :uploadtype="2"
                   :orgid="orgid"
                   :onSuccess="handleSuccess"
                   :before-upload="beforeAvatarUpload">
          <div class="addImg">
            <span v-show="!CoverPicture"
                  style="font-weight: 100;font-size: 40px;">+</span>
            <span v-show="!CoverPicture">图片上传</span>
            <img v-show="CoverPicture"
                 :src="CoverPicture"
                 alt="">
          </div>
        </webupload>
      </div>
      <p class="tip"
         style="margin-left:43px;margin-top:-10px;">注：支持jpg、jpeg、png格式；图片小于2M；图片比例670px*378px</p>
      <div class="row"
           style="justify-content:center;margin-bottom:0;">
        <div class="addBtn"
             @click="toAdd">
          <span>提交</span>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="isShow"
               @close="closeShow"
               class="AddResources"
               :show-close="false"
               title="课程资源"
               width="300px">
      <div class="row">
        <span>标题：</span>
        <span>{{title}}</span>
      </div>
      <div class="row">
        <span>视频：</span>
        <div class="mp4box">
          <video :src="resUrl"
                 controlsList='nodownload'
                 controls="controls"></video>
        </div>
      </div>
      <div class="row">
        <span>封面：</span>
        <div class="addImg">
          <span v-show="!CoverPicture">暂无</span>
          <img v-show="CoverPicture"
               :src="CoverPicture"
               alt="">
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import webupload from '../webupload/webupload.vue';
import pagination from '../../views/components/page/paginationset';
export default {
  components: {
    webupload,
    pagination
  },
  props: {
    isAddRes: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pageIndex: 1,
      pageSize: 6,
      pageCount: 0,
      storeList: [],
      isAddRes2: false,
      title: '',
      orgid: 0,
      resUrl: '',
      resId: 0,
      CoverPicture: '',
      cid: 0,
      type: 4,
      typeList: [{
        value: 4,
        label: '不限'
      }, {
        value: 1,
        label: '待审核'
      }, {
        value: 2,
        label: '驳回'
      }],
      isShow: false,
      spaceMax: 0,
      spentSpace: 0
    };
  },
  watch: {
    isAddRes () {
      this.isAddRes2 = this.isAddRes
    }
  },
  created () {
    this.orgid = Number(localStorage.getItem('storeId'))
    this.getList()
  },
  methods: {
    handleSuccess (response) {
      this.CoverPicture = response.ossfileurl;
    },
    handleSuccess2 (response) {
      this.resId = response.resid;
      this.resUrl = response.ossfileurl
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    beforeResUpload (file) {
      let spent = this.spaceMax - this.spentSpace
      const bool = file.size / 1024 / 1024 < spent;
      if (!bool) {
        this.$message.error('上传课程资源总量不能超过' + this.spaceMax + 'MB!');
      }
      return bool;
    },
    getList () {
      this.pageIndex = 1
      this.GetMyStoreList()
    },
    GetMyStoreList () {
      this.httphelper.post('/api/EnterpriseApi/GetIntCourseApplyPageList', {
        type: this.type,
        orgid: this.orgid,
        page: this.pageIndex,
        limit: this.pageSize
      })
        .then(res => {
          if (res.data.code == 200) {
            this.storeList = res.data.data
            this.pageCount = res.data.totalcount
          }
        });
      this.httphelper
        .get('/api/EnterpriseApi/GetOrgConfigById', {
          orgId: this.orgid
        })
        .then(res => {
          if (res.code == 200) {
            this.spaceMax = res.data.spaceMax
            this.spentSpace = res.data.spentSpace
          }
        });
    },
    toAdd () {
      if (this.title == '') {
        return this.$message({
          message: '标题不能为空',
          type: 'warning'
        });
      } else if (this.CoverPicture == '') {
        return this.$message({
          message: '请上传封面',
          type: 'warning'
        });
      } else if (this.resId == 0) {
        return this.$message({
          message: '请上传视频',
          type: 'warning'
        });
      }
      this.httphelper.post('/api/EnterpriseApi/SaveIntCourseApply', {
        id: this.cid,
        orgid: this.orgid,
        title: this.title,
        CoverpictureUrl: this.CoverPicture,
        resid: this.resId
      })
        .then(res => {
          if (res.data.code == 200) {
            this.GetMyStoreList()
            if (this.cid == 0) {
              this.$message({
                message: '新增成功',
                type: 'success'
              });
            } else {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
            }
            this.closeAddRes()
          }
        });
    },
    pageChange (page) {
      if (page == this.pageIndex) {
        return;
      }
      this.pageIndex = page;
      this.GetMyStoreList()
    },
    closeAddRes () {
      this.title = ''
      this.cid = 0
      this.CoverPicture = ''
      this.resId = 0
      this.resUrl = ''
      this.$emit('closeAddRes')
    },
    openAddRes () {
      this.$emit('openAddRes')
    },
    toUpdataResources (id) {
      this.httphelper.get('/api/EnterpriseApi/GetIntCourseAuditById', {
        id: id
      })
        .then(res => {
          if (res.code == 200) {
            this.title = res.data.c_Title
            this.cid = id
            this.CoverPicture = res.data.coverpicture
            this.resId = res.data.resId
            this.resUrl = res.data.res_Url
            this.openAddRes()
          }
        });
    },
    toShowResources (id) {
      this.httphelper.get('/api/EnterpriseApi/GetIntCourseAuditById', {
        id: id
      }).then(res => {
        if (res.code == 200) {
          this.title = res.data.c_Title
          this.cid = id
          this.CoverPicture = res.data.coverpicture
          this.resId = res.data.resId
          this.resUrl = res.data.res_Url
          this.isShow = true
        }
      });
    },
    closeShow () {
      this.title = ''
      this.cid = 0
      this.CoverPicture = ''
      this.resId = 0
      this.resUrl = ''
      this.isShow = false
    },
    toDeleteResources (id) {
      this.httphelper.post('/api/EnterpriseApi/DelIntCourseAudit', {
        id: id
      })
        .then(res => {
          if (res.data.code == 200) {
            this.GetMyStoreList()
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          }
        });
    }
  },
};
</script>
<style lang="scss" scoped>
.listbox {
    width: 100%;
    margin-top: 20px;
}
.listbox table {
    width: 100%;
    border-collapse: collapse;
}
.listbox th {
    height: 44px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    border-color: #e2e2e2;
    border: 1px solid #e2e2e2;
}
.listbox td {
    height: 58px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    background: #fafafa;
    text-align: center;
    border: 1px solid #e2e2e2;
}
.row {
    display: flex;
    margin-bottom: 20px;
    .toptip {
        font-size: 15px;
        line-height: 15px;
        margin-right: 20px;
    }
}
.addmp4box {
    width: 113px;
    height: 40px;
    background: #ffffff;
    border: 1px solid #e2e2e2;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    padding: 0 13px;
    box-sizing: border-box;
    cursor: pointer;
}
.mp4box video {
    max-width: 200px;
    max-height: 200px;
}
.mp4box span {
    margin-left: 10px;
    color: #0b8586;
}
.addImg {
    width: 160px;
    height: 104px;
    background: #ffffff;
    border: 1px solid #e6e6e6;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #a8a8a8;
    align-items: center;
    justify-content: space-around;
}
.addImg img {
    width: 160px;
    height: 104px;
    border-radius: 5px;
    cursor: pointer;
}
.tip {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0b8586;
    margin-bottom: 20px;
}
.addBtn {
    width: 165px;
    height: 40px;
    background: #0b8586;
    border-radius: 20px;
    line-height: 40px;
    text-align: center;
    color: #ffffff;
    cursor: pointer;
}
</style>